import {
  get,
  post,
  delet,
  put
} from '@/utils/request'
import { http_post_params } from '@/utils/index'

// 医生登录
export function doctorLogin(data) {
  return post(`/misnPc/doctorLogin/login`,data)
}
// 医生注册
export function doctorRegister(data) {
  return post(`/misnPc/doctorLogin/register`,data)
}
// 获取验证码
export function getCode(data) {
  return get(`/misnPc/doctorLogin/getCode`,data)
}
// 字典值
export function getDictValue(data) {
  return get(`/misnPc/dict/list`,data)
}
// 获取医生info
export function getUserInfo(data) {
  return get(`/misnPc/user/userInfo`,data)
}
// 更新用户信息
export function updateUserInfo(data) {
  return post(`/misnPc/user/updateUserInfo`,data)
}
// 更新邮箱
export function updateEmail(data) {
  return post(`/misnPc/user/updateEmail`,data)
}
// 更新手机号
export function updatePhone(data) {
  return post(`/misnPc/user/updatePhone`,data)
}
// 全局搜索用户
export function searchUser(data) {
  return get(`/misnPc/user/page`,data)
}
// 用户关注取消关注
export function followUser(data) {
  return get(`/misnPc/user/isFollow`,data)
}
// 关注列表
export function getFollowList(data) {
  return get(`/misnPc/user/followList`,data)
}
// 粉丝列表
export function getFansList(data) {
  return get(`/misnPc/user/fanList`,data)
}
// 我的病例列表
export function getMyCaseList(data) {
  return get(`/misnPc/case/myCase/page`,data)
}
// 病例删除
export function deleteCase(data) {
  return get(`/misnPc/case/user/deleteCase`,data)
}
// 我的视频列表
export function getMyVideoList(data) {
  return get(`/misnPc/video/myVideo/page`,data)
}
// 视频删除
export function deleteVideo(data) {
  return get(`/misnPc/video/user/deleteVideo`,data)
}
// 我的病例收藏
export function getMyCaseCollectList(data) {
  return get(`/misnPc/case/favorite/page`,data)
}
// 我的视频收藏
export function getMyVideoCollectList(data) {
  return get(`/misnPc/video/favorite/page`,data)
}
// 病例浏览记录
export function getCaseRecordList(data) {
  return get(`/misnPc/case/viewHistory/page`,data)
}
// 视频浏览记录
export function getVideoRecordList(data) {
  return get(`/misnPc/video/viewHistory/page`,data)
}
// 系统消息
export function getSystemMsgList(data) {
  return get(`/misnPc/systemMessage/page`,data)
}
// 系统消息详情
export function getSystemMsgDetail(data) {
  return get(`/misnPc/systemMessage/detail`,data)
}
// 系统消息红点
export function getSystemMsgRedPoint(data) {
  return get(`/misnPc/systemMessage/readRed`,data)
}
// 其他用户详情
export function getOtherUserInfo(data) {
  return get(`/misnPc/user/otherUserInfo`,data)
}
// 其他用户的病例
export function getOtherUserCaseList(data) {
  return get(`/misnPc/case/otherUserCase/page`,data)
}
// 其他用户视频
export function getOtherUserVideoList(data) {
  return get(`/misnPc/video/otherUserVideo/page`,data)
}
// 记录浏览历史 + 详情的浏览次数 有token 传token 没有不传
export function viewHistoryAdd(data) {
  return post(`/misnPc/other/viewHistory/add`,data)
}
// 埋点
export function addLog(data) {
  return post(`/misnPc/other/userTracking/add`,data)
}
// ip获取国家
export function getCountryByIp(data) {
  return get(`/misnPc/IPAddress/getCountry`,data)
}
// 获取uuid
export function getUuid(data) {
  return get(`/misnPc/accept/getUUID`,data)
}
// uuid 更新到用户
export function acceptUpdateUuid(data) {
  return get(`/misnPc/accept/update`,data)
}

// 合作厂家入驻
export function manufacturerRegister(data) {
  return post(`/misnPc/manufacturerLogin/register`,data)
}


// 厂家登录
export function manufacturerLogin(data) {
  return post(`/misnPc/manufacturerLogin/login`,data)
}
// 获取厂家info
export function getManufactUrerInfo(data) {
  return get(`/misnPc/manufacturerUser/userInfo`,data)
}
// 厂家产品列表
export function getManufacturerProductList(data) {
  return get(`/misnPc/manufacturerUser/myProductList`,data)
}
// 厂家新增产品
export function addManufacturerProduct(data) {
  return post(`/misnPc/manufacturerUser/addOrUpdate`,data)
}
// 厂家产品详情
export function getManufacturerProductDetail(data) {
  return get(`/misnPc/manufacturerUser/detail`,data)
}
// 厂家产品删除
export function deleteManufacturerProduct(data) {
  return get(`/misnPc/manufacturerUser/delete`,data)
}
// 厂家用户信息修改
export function updateManufacturerUserInfo(data) {
  return post(`/misnPc/manufacturerUser/updateUserInfo`,data)
}